module.exports = __webpack_public_path__ + "img/Flag_of_the_Solomon_Islands.79392615.svg";